(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lazy-load-image"] && !Shopify.designMode) return;
  try {
    class LazyLoadImage extends HTMLImageElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // 确保元素已连接到DOM
      if (!this.isConnected) return;

      // 获取picture元素
      const pictureElement = this.closest('picture');
      if (pictureElement) {
        // 监听窗口大小变化，重新处理懒加载
        window.addEventListener('resize', this.lazyLoading.bind(this));

        // 创建一个MutationObserver来监听属性变化
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            // 如果src或srcset属性发生变化，重新处理懒加载
            if (mutation.attributeName.includes('src') || mutation.attributeName.includes('srcset')) {
              this.lazyLoading();
            }
          });
        });

        // 开始观察当前元素的属性变化
        observer.observe(this, { attributes: true });

        // 初始化时立即处理懒加载
        this.lazyLoading();
      }
    }

    // 获取最近的picture父元素
    get media() {
      return this.closest('picture');
    }

    // 处理懒加载逻辑
    lazyLoading() {
      // 如果图片尚未加载完成且没有loaded类
      if (this.media && !this.complete && !this.classList.contains('loaded')) {
        // 添加loading类到media元素，显示加载状态
        this.media.classList.add('loading');

        // 监听图片加载完成事件
        this.addEventListener(
          'load',
          () => {
            // 创建一个回调函数，用于更新DOM
            const updateDOM = () => {
              // 给图片添加loaded类
              this.classList.add('loaded');
              // 从media元素移除loading类
              if (this.media) {
                this.media.classList.remove('loading');
              }
            };

            // 使用requestIdleCallback（如果可用）或setTimeout来延迟执行DOM更新
            // 这样可以避免阻塞主线程，提高性能
            if (window.requestIdleCallback) {
              window.requestIdleCallback(updateDOM, { timeout: 150 });
            } else {
              setTimeout(updateDOM);
            }
          },
          false
        );
      }
    }
  }

  // 检查是否已经注册过
  if (!customElements.get('lazy-load-image')) {
    // 注册自定义元素，扩展自img标签
    customElements.define('lazy-load-image', LazyLoadImage, { extends: 'img' });
  }
  } catch(e) { console.error(e); }
})();

})();
